import React, { useEffect, useState } from "react";
import "./GroupLoansCheckProperties.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";

const GroupLoansCheckProperties = ({ selectedLoan, setSelectedView }) => {
    const [groupsProperties, setGroupsProperties] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(()=>{
        getGroupLoanProperties();
    },[]);

    const getGroupLoanProperties = async() => {
        console.log("selectedLoan----------",selectedLoan);
        try {
            const response = await commonRunQuery(286, selectedLoan?.loangroups?.groupid ? selectedLoan?.loangroups?.groupid : selectedLoan?.lgm?.groupid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setGroupsProperties(groupsArray[0]);
              console.log("getGroupLoanProperties_response==========",groupsArray);
            } else {
                setGroupsProperties([]);
            }
      
        } catch (error) {
            console.log("getGroupLoanProperties_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box>
            <Box className="d-flex justify-content-between">
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                >
                    Check Properties
                </Typography>

                <Button
                    className="fs-size-12 paiy-blue text-white"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setSelectedView(null);
                    }}
                >
                    Return
                </Button>
            </Box>

            {loading ? (
                    <Box
                        sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                <Box>
                    <Box className="user-accounts-tab mt-4">
                        <Box className="">
                            <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                {/* Left Column */}
                                <Box minWidth="300px" flex={1}>
                                    {[
                                        { label: "Group ID", value: groupsProperties?.loangroups?.groupid },
                                        { label: "Group Name", value: groupsProperties?.loangroups?.groupname },
                                        { label: "Group Admin User", value: groupsProperties?.loangroups?.groupadminuser },
                                        { label: "No. of Members", value: groupsProperties?.loangroups?.noofmembers },
                                        { label: "Status", value: groupsProperties?.loangroups?.status == "1" ? "Active" : "Closed" },
                                        { label: "Lock Flag", value: groupsProperties?.loangroups?.lockflag }
                                    ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value}</Box>
                                        </Box>
                                    ))}
                                </Box>

                                {/* Right Column */}
                                <Box minWidth="300px" flex={1}>
                                    {[
                                        { label: "Interest Rate", value: groupsProperties?.loangroups?.interestrateforloans },
                                        { label: "Price Per Share", value: groupsProperties?.loangroups?.pricepershare },
                                        { label: "Duration in months", value: groupsProperties?.loangroups?.durationinmonths },
                                        { label: "Min Contribution", value: groupsProperties?.loangroups?.minimumcontribution },
                                        { label: "Last Execution Time", value: groupsProperties?.loangroups?.lastexecutiontime },
                                        { label: "Open for Contribution", value: groupsProperties?.loangroups?.openforcontribution },
                                    ].filter(Boolean).map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value}</Box>
                                        </Box>
                                    ))}
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default GroupLoansCheckProperties;
